<template>
  <div class="labtest shadow-sm">
    <div
      v-for="e in caseLabtests(value)"
      :key="`labtest-${e.id}`"
      class="row list no-gutters"
    >
      <div class="col-auto item result-type-value">
        <a class="py-2 px-3 h-100">
          <span class="text-success" v-if="e.result_type === 'present'">
            <yes-icon></yes-icon>
            {{ $t(e.result_type) }}
          </span>
          <span class="text-danger" v-else-if="e.result_type === 'absent'">
            <no-icon></no-icon>
            {{ $t(e.result_type) }}
          </span>
          <span class="text-danger" v-else-if="e.result_type === 'very_low'">
            <double-angle-icon></double-angle-icon>
            {{ $t(e.result_type) }}
          </span>
          <span class="text-warning" v-else-if="e.result_type === 'low'">
            <angle-icon></angle-icon>
            {{ $t(e.result_type) }}
          </span>
          <span class="text-primary" v-else-if="e.result_type === 'normal'">
            <normal-icon></normal-icon>
            {{ $t(e.result_type) }}
          </span>
          <span class="text-warning" v-else-if="e.result_type === 'high'">
            <span class="d-inline-block rotate-180"
              ><angle-icon></angle-icon
            ></span>
            {{ $t(e.result_type) }}
          </span>
          <span class="text-danger" v-else-if="e.result_type === 'very_high'">
            <span class="d-inline-block rotate-180"
              ><double-angle-icon></double-angle-icon
            ></span>
            {{ $t(e.result_type) }}
          </span>
        </a>
      </div>
      <div class="col item">
        <a class="py-2 px-3" v-if="labtestById(e.id)">
          {{ labtestById(e.id).name[authLocale] }}
        </a>
        <a class="py-2 px-3" v-else>
          {{ e.id }}
        </a>
      </div>
      <div class="col-auto item item-last">
        <a class="py-2 px-3 pointer" @click.prevent="deleteLabtest(e.id)">
          <span class="text-primary">
            <remove-icon></remove-icon>
          </span>
        </a>
      </div>
    </div>
    <div class="list">
      <div class="item item-last item-bottom">
        <a
          class="py-3 px-3 pointer text-primary"
          @click.prevent="showLabtests = !showLabtests"
        >
          <strong :class="{ closed: !showLabtests, open: showLabtests }">
            <small>
              <plus-icon v-if="!showLabtests"></plus-icon>
              <minus-icon v-else></minus-icon>
            </small>
            {{ $t("addLabtests") }}
          </strong>
        </a>
      </div>
    </div>
    <div
      v-for="cat in categories"
      :key="`labtest-cat-${cat[authLocale]}`"
      class="mx-4"
    >
      <a
        class="labtest-cat pointer svg-sm text-primary font-weight-bold d-block p-2"
        v-if="showLabtests"
        @click.prevent="
          $set(isVisible, cat[authLocale], !isVisible[cat[authLocale]])
        "
      >
        <small>
          <plus-icon v-if="!isVisible[cat[authLocale]]"></plus-icon>
          <minus-icon v-else></minus-icon>
        </small>
        {{ cat[authLocale] }}
      </a>
      <div
        class="border-bottom"
        v-show="showLabtests && isVisible[cat[authLocale]]"
      >
        <div
          class="list row no-gutters"
          v-for="val of byCategory(cat)"
          :key="`labtest-add-${val.id}`"
        >
          <div class="item item-last col mb-2 border-bottom">
            <a class="py-2 px-3">
              {{ val.name[authLocale] }}
            </a>
            <div class="row no-gutters">
              <template v-for="r of val.results">
                <div
                  class="col"
                  :key="`present-${r.id}`"
                  v-if="r.type === 'present'"
                >
                  <a
                    class="text-success py-2 px-3 h-100 pointer text-center d-block"
                    @click.prevent="addLabtest(val.id, 'present')"
                  >
                    <yes-icon></yes-icon>
                    <span class="d-none d-lg-inline pl-2">{{
                      $t("present")
                    }}</span>
                  </a>
                </div>
              </template>
              <template v-for="r of val.results">
                <div
                  class="col"
                  :key="`absent-${r.id}`"
                  v-if="r.type === 'absent'"
                >
                  <a
                    class="text-danger py-2 px-3 h-100 pointer text-center d-block"
                    @click.prevent="addLabtest(val.id, 'absent')"
                  >
                    <no-icon></no-icon>
                    <span class="d-none d-lg-inline pl-2">{{
                      $t("absent")
                    }}</span>
                  </a>
                </div>
              </template>
              <template v-for="r of val.results">
                <div
                  class="col"
                  :key="`very-low-${r.id}`"
                  v-if="r.type === 'very_low'"
                >
                  <a
                    class="text-danger py-2 px-3 h-100 pointer text-center d-block"
                    @click.prevent="addLabtest(val.id, 'very_low')"
                  >
                    <double-angle-icon></double-angle-icon>
                    <span class="d-none d-lg-inline pl-2">{{
                      $t("very_low")
                    }}</span>
                  </a>
                </div>
              </template>
              <template v-for="r of val.results">
                <div class="col" :key="`low-${r.id}`" v-if="r.type === 'low'">
                  <a
                    class="text-warning py-2 px-3 h-100 pointer text-center d-block"
                    @click.prevent="addLabtest(val.id, 'low')"
                  >
                    <angle-icon></angle-icon>
                    <span class="d-none d-lg-inline pl-2">{{ $t("low") }}</span>
                  </a>
                </div>
              </template>
              <template v-for="r of val.results">
                <div
                  class="col"
                  :key="`normal-${r.id}`"
                  v-if="r.type === 'normal'"
                >
                  <a
                    class="text-primary py-2 px-3 h-100 pointer text-center d-block"
                    @click.prevent="addLabtest(val.id, 'normal')"
                  >
                    <normal-icon></normal-icon>
                    <span class="d-none d-lg-inline pl-2">{{
                      $t("normal")
                    }}</span>
                  </a>
                </div>
              </template>
              <template v-for="r of val.results">
                <div class="col" :key="`high-${r.id}`" v-if="r.type === 'high'">
                  <a
                    class="text-warning py-2 px-3 h-100 pointer text-center d-block"
                    @click.prevent="addLabtest(val.id, 'high')"
                  >
                    <span class="d-inline-block rotate-180"
                      ><angle-icon></angle-icon
                    ></span>
                    <span class="d-none d-lg-inline pl-2">{{
                      $t("high")
                    }}</span>
                  </a>
                </div>
              </template>
              <template v-for="r of val.results">
                <div
                  class="col"
                  :key="`very-high-${r.id}`"
                  v-if="r.type === 'very_high'"
                >
                  <a
                    class="text-danger py-2 px-3 h-100 pointer text-center d-block"
                    @click.prevent="addLabtest(val.id, 'very_high')"
                  >
                    <span class="d-inline-block rotate-180"
                      ><double-angle-icon></double-angle-icon
                    ></span>
                    <span class="d-none d-lg-inline pl-2">{{
                      $t("very_high")
                    }}</span>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
import AngleIcon from '@/components/Icons/Angle'
import DoubleAngleIcon from '@/components/Icons/DoubleAngle'
import RemoveIcon from '@/components/Icons/Remove'
import NormalIcon from '@/components/Icons/Normal'
import PlusIcon from '@/components/Icons/Plus'
import MinusIcon from '@/components/Icons/Minus'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    YesIcon,
    NoIcon,
    AngleIcon,
    RemoveIcon,
    DoubleAngleIcon,
    PlusIcon,
    MinusIcon,
    NormalIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      labtest: null,
      keyword: null,
      showLabtests: false,
      isVisible: {}
    }
  },
  mounted () {
    this.fetchLabtests()
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      labtests: 'labtest/labtests',
      categories: 'labtest/categories',
      byCategory: 'labtest/byCategory',
      labtestById: 'labtest/byId',
      caseById: 'pcase/byId',
      caseLabtests: 'pcase/labtests',
      patientGender: 'pcase/patientGender',
      patientAge: 'pcase/patientAge'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      pushLabtest: 'pcase/pushLabtest',
      removeLabtest: 'pcase/removeLabtest',
      setLabtests: 'labtest/set'
    }),
    async fetchLabtests () {
      try {
        const patientAge = this.patientAge(this.value)
        const params = {
          language: this.authLocale,
          age: patientAge.value,
          age_unit: patientAge.unit
        }
        const response = await this.axios.get('/api/static/labtests/extended', {
          params
        })
        this.setLabtests(response.data.data)
      } catch (err) {
        this.setError(err)
      }
    },
    async addLabtest (labtestId, choice) {
      try {
        const params = {
          labtest_id: labtestId,
          result_type: choice
        }
        const response = await this.axios.post(
          `/api/patient-cases/${this.value}/labtests`,
          params
        )
        this.pushLabtest({ id: this.value, labtest: response.data.data })
      } catch (err) {
        this.setError(err)
      }
      this.labtest = null
    },
    async deleteLabtest (labtestId) {
      try {
        const params = {
          labtest_id: labtestId
        }
        await this.axios.post(
          `/api/patient-cases/${this.value}/labtests/remove`,
          params
        )
        this.removeLabtest({ id: this.value, labtestId: labtestId })
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.labtest {
  .labtest-list {
    max-height: 400px;
    overflow: auto;
  }
  .result-type-value {
    width: 185px;
  }
  .labtest-cat {
    transition: all 0.2s;
  }
}
</style>
<i18n>
{
  "ka": {
      "addLabtests": "მონაცემის დამატება",
      "search": "ძიება",
      "present": "ფიქსირდება",
      "absent": "არ ფიქსირდება",
      "very_low": "ძალიან დაბალი",
      "low": "დაბალი",
      "normal": "ნორმა",
      "high": "მაღალი",
      "very_high": "ძალიან მაღალი"
  },
  "en": {
      "addLabtests": "Add Data",
      "search": "Search",
      "present": "Present",
      "absent": "Absent",
      "very_low": "Very Low",
      "low": "Low",
      "normal": "Normal",
      "high": "High",
      "very_high": "Very High"
  }
}
</i18n>
